import { FC } from "react";
import { Container, Row, Col } from "react-bootstrap";
import styles from "./WhyRwanda.module.css";

interface InfoBox {
  title: string;
  description: string;
}

const infoBoxes: InfoBox[] = [
  {
    title: "Time zone aligned",
    description: "0-1 hour difference from the Nordics",
  },
  {
    title: "Similar work culture",
    description: "Focus on quality, honesty and delivery",
  },
  {
    title: "English proficiency",
    description: "English as their official work language",
  },
  {
    title: "Cost-Quality Balance",
    description:
      "50-60% savings vs. Danish rates, with Danish technical oversight & presence",
  },
  {
    title: "Modern infrastructure",
    description:
      "100% 4G coverage, government backed tech sector investment and recognized institutions such as Carnegie Mellon University Africa",
  },
  {
    title: "Real-time collaboration",
    description:
      "7 hours of daily overlap. Availability for daily standups, pair programming etc.",
  },
];

const WhyRwanda: FC = () => {
  return (
    <section id="about" className={styles.whyRwanda}>
      <Container>
        <h2 className={styles.title}>Why Rwanda</h2>
        <Row>
          {infoBoxes.map((box, index) => (
            <Col key={index} md={6} lg={4} className="mb-4">
              <div className={styles.infoBox}>
                <h3 className={styles.boxTitle}>{box.title}</h3>
                <p className={styles.boxDescription}>{box.description}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default WhyRwanda;
